export default "__VITE_ASSET__LtL_FQhd__"